import React, {useEffect, useState} from "react";
import {MobXProviderContext} from "mobx-react";


export const useStores = () => React.useContext(MobXProviderContext);
export const useForceUpdate = () => {
    const [, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

export const useBackDrop = (dropRef, dragOn, dragOff, dragEnd) => {
    useEffect(() => {
        setDragListeners();

        return () => {
            unSetListeners();
        }
        // eslint-disable-next-line
    }, []);


    function setDragListeners() {
        const div = dropRef.current;
        if (!div) {
            return;
        }
        div.addEventListener('dragenter', handleDragIn);
        div.addEventListener('dragleave', handleDragOut);
        div.addEventListener('dragover', handleDrag);
        div.addEventListener('drop', handleDrop)
    }

    function unSetListeners() {
        const div = dropRef.current;
        if (!div) {
            return;
        }
        div.removeEventListener('dragenter', handleDragIn);
        div.removeEventListener('dragleave', handleDragOut);
        div.addEventListener('dragover', handleDrag);
        div.removeEventListener('drop', handleDrop)
    }


    function handleDragIn(e) {
        e.preventDefault();
        e.stopPropagation();
        dragOn();
    }

    function handleDragOut(e) {
        const div = dropRef.current;
        const rect = div.getBoundingClientRect();
        const boundaries = {
            x1: rect.left,
            y1: rect.top,
            x2: rect.left + rect.width,
            y2: rect.top + rect.height,
        };

        const isInsideRef = e.x <= boundaries.x2 && e.x >= boundaries.x1 && e.y <= boundaries.y2 && e.y >= boundaries.y1;
        if (isInsideRef) {
            return;
        }
        dragOff();
        e.preventDefault();
        e.stopPropagation();
    }

    function handleDrag(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    async function handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        handleDragOut(e);
        dragEnd(e.dataTransfer.files);
    }
}
